module.exports = __webpack_public_path__ + "static/images/01ce7eaa.png";